import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationsService {

  private communicationSummarySource = new BehaviorSubject<CommunicationSummary[]>(null);
  communicationsSummary = this.communicationSummarySource.asObservable();

  private communicationSource = new BehaviorSubject<Communication>(null);
  communication = this.communicationSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  async postCommunication(communicationTemplateId: number, parameters: { [key: string]: string; }, appropriatorIds: Array<number>) {
    var comm = {
      communicationTemplateId: communicationTemplateId,
      parameters: parameters,
      communicationRecipients: appropriatorIds.map(x => ({ recipientType: CommunicationRecipientType.Appropriator, recipientIdentifier: x.toString() }))
    }
    this.http.post(`${this.baseUrl}api/communication/fromTemplate`, comm, { observe: 'response' }).subscribe(
      response => {
        if (response.status === 200) {
          return { success: true, failureMessage: null };
        }
      },
      error => {
        console.error(error);
        return { success: false, failureMessage: error };
      }
    );

    return { success: false, failureMessage: "Unknown" };
  }

  async getCommunicationsSummary() {
    this.http.get<CommunicationSummary[]>(`${this.baseUrl}api/communication/summary`).subscribe(
      response => {
        if (response) {
          this.communicationSummarySource.next(response);
        }
      },
      error => console.error(error)
    );
  }

  async getCommunication(communicationId: number) {
    this.http.get<Communication>(`${this.baseUrl}api/communication/${communicationId}`).subscribe(
      response => {
        if (response) {
          this.communicationSource.next(response);
        }
      },
      error => {
        console.error(error);
      }
    );
  }

}

export interface CommunicationFromTemplate {
  communicationTemplateId: number,
  parameters: Map<string, string>,
  communicationRecipients: Array<CommunicationRecipient>
}
export interface Communication {
  communicationId: number,
  requestingModule: string,
  subject: string,
  body: string,
  bodyIsHtml: boolean,
  createdDate: Date,
  createdBy: string,
  modifiedDate: Date,
  modifiedBy: string,
  communicationRecipients: Array<CommunicationRecipient>,
  emails: Array<Email>
}
export interface CommunicationRecipient {
  communicationRecipientId: number,
  recipientType: string,
  recipientIdentifier: string,
  recipientName: string
}
export enum CommunicationRecipientType {
  Appropriator = 0,
  Role = 1,
  User = 2
}
export interface CommunicationSummary {
  communicationId: number,
  requestingModule: string,
  subject: string,
  createdDate: Date,
  createdBy: string,
  recipients: string,
  emailStatus: string
}
export interface Email {
  emailId: number,
  scheduledDate: Date,
  deliveredDate: Date,
  error: string,
  fromAddress: string,
  toAddress: string,
  ccAddress: string,
  bccAddress: string
}
